<template>
  <div class="container">
    <div class="switch-container">
      <!-- Toggle switch -->
      <label class="switch">
        <input
          type="checkbox"
          v-model="is2FAEnabled"
          :disabled="loading || error"
          @change="handle2FAToggle"
        />
        <span class="slider"></span>
      </label>
      <!-- Label showing the switch status -->
      <span class="switch-label"> Autenticação de 2 Fatores </span>
    </div>

    <!-- Error message -->
    <div v-if="error" class="error-message">
      {{ errorMessage }}
    </div>
  </div>
</template>

<script>
import { getUser, updateMultipleUsersSms2fa } from "@/services/user.service";
//import AuthApp from "../../main";

export default {
  name: "TwoFactorToggle",
  data() {
    return {
      is2FAEnabled: false,
      allSubusers: [],
      loading: false,
      error: false,
      errorMessage: "",
      loader: null, // will hold the loading instance
    };
  },
  async mounted() {
    await this.fetchSubusers();
  },
  methods: {
    async fetchSubusers(showLoader = true) {
      // Show loader only if one doesn't exist
      if (showLoader && !this.loader) {
        this.error = false;
        this.loading = true;
        this.loader = this.$loading.show({
          container: null,
          canCancel: true,
          onCancel: this.onCancel,
          isFullPage: true,
        });
      }

      try {
        const [res, err] = await getUser({ page: 0, size: 1000 });
        if (err) throw new Error("Failed to fetch users");

        this.allSubusers = res.items;
        this.updateSwitchState();
      } catch (err) {
        this.error = true;
        this.errorMessage = "Error loading user data. Please try again later.";
      } finally {
        // Only hide loader if we created it here
        if (showLoader && this.loader) {
          this.loader.hide();
          this.loader = null;
          this.loading = false;
        }
      }
    },

    updateSwitchState() {
      if (this.allSubusers.length === 0) {
        this.is2FAEnabled = false;
        return;
      }

      /*let userStatusText = '';
      const displayLimit = Math.min(5, this.allSubusers.length);
      for (let i = 0; i < displayLimit; i++) {
        const user = this.allSubusers[i];
        userStatusText += `${user.email}: ${user.twoFactorEnabled}\n`;
      }
      this.$toast.add({
        severity: "info",
        summary: "User 2FA Status",
        detail: userStatusText,
        life: 7000,
      });*/

      // Enable 2FA only if every subuser already has it enabled
      this.is2FAEnabled = this.allSubusers.every(
        (user) => user.twoFactorEnabled
      );
    },

    async handle2FAToggle() {
      this.error = false;
      this.loading = true;
      // Show a full-page loader on toggle as well.
      this.loader = this.$loading.show({
        container: null,
        canCancel: true,
        onCancel: this.onCancel,
        isFullPage: true,
      });

      try {
        const newStatus = this.is2FAEnabled;
        const userIds = this.allSubusers.map((user) => user.email);
        const payload = { userIds, is2FAEnabled: newStatus };

        if (this.allSubusers.length === 0) {
          throw new Error("No subusers available to update");
        }

        // Update all subusers
        const [, err] = await updateMultipleUsersSms2fa(payload);
        if (err) {
          this.$toast.add({
            severity: "error",
            summary: "Erro",
            detail: `Erro a atualizar todos os utilizadores`,
            life: 3000,
          });
          throw new Error("Failed to update multiple users");
        }

        // Verify the updates by re-fetching users
        await this.fetchSubusers(false);
        if (
          !this.allSubusers.every((user) => user.twoFactorEnabled === newStatus)
        ) {
          this.$toast.add({
            severity: "error",
            summary: "Erro",
            detail: `De momento não é possivel. Por favor, tente mais tarde.`,
            life: 3000,
          });
          throw new Error("Some users failed to update");
        }
        this.$toast.add({
          severity: "info",
          summary: "Info",
          detail: "Autenticação atualizada para todos os utilizadores",
          life: 3000,
        });
      } catch (err) {
        this.error = true;
        this.is2FAEnabled = !this.is2FAEnabled;
      } finally {
        this.loader.hide();
        this.loading = false;
      }
    },

    onCancel() {
      console.log("Loading cancelled");
      if (this.loader) {
        this.loader = null;
      }
    },
  },
};
</script>

<style scoped>
.container {
  padding: 16px;
  font-family: Arial, sans-serif;
}

/* Container for the switch and its labels */
.switch-container {
  display: flex;
  align-items: center;
}

/* Toggle switch base */
.switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 24px;
}

/* Hide the default checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider (the switch button) */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
  border-radius: 24px;
}

/* The slider's circle */
.slider:before {
  position: absolute;
  content: "";
  height: 20px;
  width: 20px;
  left: 2px;
  bottom: 2px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}

/* When the checkbox is checked, change background color */
input:checked + .slider {
  background-color: #bad80a;
}

/* Move the slider's circle to the right when checked */
input:checked + .slider:before {
  transform: translateX(26px);
}

/* Spacing for the switch label */
.switch-label {
  margin-left: 10px;
  font-size: 14px;
}

/* Error message styling */
.error-message {
  margin-top: 10px;
  color: red;
  font-size: 14px;
}
</style>
